import React, { Suspense } from "react";

const LazyLottie = React.lazy(() => import("../commons/LazyLottie"));


function QLottie({ styles }) {
	return <Suspense fallback={<p>Loading...</p>}>
		<LazyLottie styles={styles} />
	</Suspense>
}

export default QLottie;